import { AuthGuard } from "@dis/auth";
import { JtmsRoutes, groupOverview } from "../core/routing/route-data";

export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "quality" },
    children: [
      groupOverview(() => import("../feature/overviews/quality-overview").then((m) => m.QualityOverview)),
      {
        path: "inspection-queue",
        data: { navOrder: 1 },
        loadComponent: () =>
          import("../feature/shop/inventory/inspection-queue/inspection-queue").then((m) => m.InspectionQueue),
        title: "Inspection Queue",
      },
      {
        path: "received-tool-assessment",
        data: { navOrder: 2 },
        loadComponent: () =>
          import("../feature/shop/ship-n-receiving/tool-assessment/tool-assessment.component").then(
            (m) => m.ToolAssessment
          ),
        title: "Assess Received Tools",
      },
      {
        path: "nde-scans",
        data: { navOrder: 3 },
        loadComponent: () =>
          import("../feature/office/inspection-file-manager/inspection-file-manager.component").then(
            (m) => m.InspectionFileManager
          ),
        title: "NDE Scans",
      },
      {
        path: "tmmde",
        data: { navOrder: 4 },
        loadComponent: () => import("../feature/shop/operations/tmmde/tmmde").then((m) => m.Tmmde),
        title: "TMMDE",
      },
      {
        path: "tpi-matrix",
        data: { navOrder: 5 },
        loadComponent: () =>
          import("../feature/shop/operations/tpi/tpi-matrix-container/tpi-matrix-container.component").then(
            (m) => m.TpiMatrixContainer
          ),
        title: "TPI Matrix",
      },
    ],
  },
] satisfies JtmsRoutes;
